import { ResourceDetailTab } from '@ciandtspike.io/plugin-ciandtspike-common';
import { RepositoryTab } from './components/RepositoryTab';

export const repositoryDetailTab: ResourceDetailTab = {
  id: 'repository',
  labelKey: 'Repositório',
  order: 20,
  appliesTo: detail => detail.specType === 'cloudrunapp',
  Component: RepositoryTab,
};
